<script>
import Layout from "@layouts/form";
import ContratoTipo from "@forms/ContratoTipo";

export default {
  page: {
    title: "Detalhes | Tipo de contrato"
  },
  components: { Layout, ContratoTipo },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Tipo de Contrato",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Tipo de Contrato",
          href: "/ContratoTipo"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <ContratoTipo :editable="editable"></ContratoTipo>
    </div>
  </Layout>
</template>
